import React, { useState, useEffect } from 'react';

import Header from './../../components/Header/';
import Footer from './../../components/Footer/';

import LoadingComponent from './../../components/Loading/';

import {Container,
		Content} from './styles';
import FormToMyAccountPage from '../../components/FormToMyAccountPage';

export default function MyAccount(){
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(false);
	}, []);

	return(
		<Container>
			<Header />
			{!!loading && (
				<LoadingComponent />
			)}

			{!loading && (
			<Content>
				<h2>EDITAR PERFIL</h2>

				<FormToMyAccountPage />
				
			</Content>
			)}
			<Footer />
		</Container>
	);
};